


































































import { Component, Vue } from 'vue-property-decorator';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import html2canvas from 'html2canvas';
@Component({
    $_veeValidate: { validator: 'new' },
})
export default class Exito extends Vue {
  private mascotasAMostrar:any = this.$store.getters.mascotasCita;
  private serviciosSelected: any = this.$store.getters.serviciosText;
  private idCitas: any = this.$store.getters.idCitaBloqueo;
  private nombresMascotas = '';
  private nombresServicios = '';
  private textoNotas = this.$store.getters.serviciosText.notas;
  private validos = true;
  private idCitasText = '';
  private paso = 7;

  private guardaRegistroCitas() {
    for (let c of this.idCitas) {
      this.$store.dispatch('guardaRegistroCallCenter', [this.$store.getters.getIdUsuarioCallCenter, c.ID_CITA])
    }
    this.$store.dispatch('resetAll');
    this.$store.commit('setUser', undefined);
    this.$router.push('/callCenter/clubpetco');
  }
  
  private print() {
    const doc = new jsPDF();
      doc.text(85, 10, '¡Cita agendada!');
      const columns = ['', 'Descripción'];
      // @ts-ignore
      doc.autoTable({
        head: [columns],
        body: [
          ['ID Citas', this.idCitasText],
          ['Tienda', this.tiendaElegidaNombre],
          ['Mascotas', this.nombresMascotas],
          ['Servicios', this.nombresServicios],
          ['Fecha y hora', this.formatDate(this.fecha) + ' - ' + this.formatHours(this.horarioCita.HORA_INI) + '-'+ this.formatHours(this.horarioCita.HORA_FIN)],
          ['Notas', this.textoNotas]
        ]
      });
      doc.save('Cita ' + this.idCitasText + ' ' + this.nombresMascotas + '.pdf');
  }

  private writeIDConfirmacion(array: any) {
    let cadena = '';
    for (const s of array) {
      cadena += s.ID_CITA + ', '
    }
    return cadena.substring(0, cadena.length - 2);
  }
  private writeServicios(array: any) {
    let cadena = '';
    for (const m of array) {
      cadena += m.mascota+ ': ';
      for (const s of m.servicio) {
        cadena += s + ', ';
      }
      cadena = cadena.substring(0, cadena.length - 2);
      cadena += '; ';
    }
    return cadena.substring(0, cadena.length - 2);
  }

  private created() {
    //Llenamos mascotas
    let stringMascotas = '';
    for (const mascota of this.mascotasAMostrar) {
      stringMascotas += mascota.NOMBRE + ', ';
    }
    stringMascotas = stringMascotas.substring(0, stringMascotas.length - 2);
    this.nombresMascotas = stringMascotas;

    this.nombresServicios = this.writeServicios(this.serviciosSelected);
    this.idCitasText = this.writeIDConfirmacion(this.idCitas);
    this.textoNotas = this.writeNotas(this.$store.getters.serviciosText);
  }

  private get tiendaElegidaNombre() {
    return this.$store.getters.tiendaElegidaNombre;
  }

  //Escribe notas
  private writeNotas(array: any) {
    let cadena = '';
    for (const m of array) {
      if (m.notas === undefined) {
        m.notas = 'Sin notas especiales';
      }
      cadena += m.mascota + ': ' + m.notas + '; ';
    }
    return cadena.substring(0, cadena.length - 2);
  }

  private get fecha() {
    return this.$store.getters.fecha;
  }

  private get horarioCita() {
    return this.$store.getters.horarioCita;
  }

  private formatDate(fecha: any) {
    const anio = fecha.substring(0, 4);
    const mes = fecha.substring(4, 6);
    const dia = fecha.substring(6, 8);
    let mesString = '';
    if (mes === '01') {
      mesString = 'Enero';
    } else if (mes === '02') {
      mesString = 'Febrero';
    } else if (mes === '03') {
      mesString = 'Marzo';
    } else if (mes === '04') {
      mesString = 'Abril';
    } else if (mes === '05') {
      mesString = 'Mayo';
    } else if (mes === '06') {
      mesString = 'Junio';
    } else if (mes === '07') {
      mesString = 'Julio';
    } else if (mes === '08') {
      mesString = 'Agosto';
    } else if (mes === '09') {
      mesString = 'Septiembre';
    } else if (mes === '10') {
      mesString = 'Octubre';
    } else if (mes === '11') {
      mesString = 'Noviembre';
    } else if (mes === '12') {
      mesString = 'Diciembre';
     }
    return dia + ' / ' + mesString + ' / ' + anio;
  }

  private formatHours(item: any ) {
    let stringDT = '';
    stringDT += item.substring(0, 2) + ':' + item.substring(3, 5);
    return stringDT;
  }
  //Botón aceptar
  private async terminar(){
    if (await this.$store.dispatch('isDefined', this.$store.getters.idCallCenter)) {
      this.guardaRegistroCitas();
    } else {
      this.$store.dispatch('resetAll');
      this.$router.push('/tiendas');
    }
  }

}
